<template>
    <div>
      <canvas id="signature-pad" width="400" height="200"></canvas>
      <button @click="clearCanvas">Limpar</button>
      <button @click="saveSignature">Salvar</button>
    </div>
  </template>

<script>

import SignaturePad from 'signature_pad';

export default {
  components: {
    SignaturePad
  },
  data() {
    return {
      signaturePad: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.signaturePad = new SignaturePad(this.$refs.signaturePad);
    });
  },
  methods: {
    clearCanvas() {
      this.signaturePad.clear();
    },
    saveSignature() {
      const signature = this.signaturePad.toDataURL();
      // Faça algo com a assinatura, como enviá-la para um servidor
    }
  }
};
</script>

<style scoped>
#signature-pad {
  border: 1px solid #000;
  background-color: #fff;
}
</style>